import { gql } from "graphql-request";
import { graphqlClient } from "@/lib/graphqlClient";
import { ADMIN_PROFILES, TMA_PROFILES } from "@/assets/constants/constants";

export type MeResponse = {
  user_find_me: {
    airports: string[];
    name: string;
    email: string;
    payrollNumber: string;
    profile: string; // aquí estaría el rol
    userId: string;
    status: string;
  };
};

const GET_ME_QUERY = gql`
  query GetMe {
    user_find_me {
      airports
      name
      email
      payrollNumber
      profile
      userId
      status
    }
  }
`;

export async function getMe() {
  const data = await graphqlClient.request<MeResponse>(GET_ME_QUERY);
  if (
    ![...ADMIN_PROFILES, ...TMA_PROFILES].includes(data.user_find_me.profile)
  ) {
    throw new Error("Unauthorized profile");
  }
  return data.user_find_me;
}
